module.exports = __webpack_public_path__ + "img/actual.33944d27.png";